import {NoGamesFoundMessageDefaultBox} from './no-games-found-message.default.box';

export const NoGamesFoundMessageBox = NoGamesFoundMessageDefaultBox;